import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import type {IssueViewerSecondaryViewServerQueryQuery} from '@github-ui/server-persisted-queries/types/IssueViewerSecondaryViewServerQuery'

// Broad node derived from the allowlisted `IssueViewerSecondaryViewQuery` generated type, which contains the field
// `useHasSubIssues` reads. Deriving from codegen keeps these shapes in sync automatically when the query changes.
type IssueNode = NonNullable<NonNullable<IssueViewerSecondaryViewServerQueryQuery['repository']>['issue']>

/**
 * The fields `useHasSubIssues` reads off an `Issue`. Consumers select these inline and forward the result here.
 *
 * Wrapped in `RelayCompat` because the spreading documents are still Relay-owned; remove it once they migrate.
 */
export type UseHasSubIssuesFragment = RelayCompat<{
  readonly subIssuesSummary: Pick<IssueNode['subIssuesSummary'], 'total'>
}>

/** Returns true if this issue has sub-issues. */
export function useHasSubIssues(data?: UseHasSubIssuesFragment | null) {
  return (data?.subIssuesSummary?.total ?? 0) > 0
}
